module.exports = __webpack_public_path__ + "static/img/birth_usebtn.b22eeac.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/scflow/birth_usebtn.png
// module id = 206
// module chunks = 32